export default __webpack_public_path__ + "static/media/reset-password-v2-dark.d08dbe80.svg";